import { z } from 'zod';

const isTsx = process.argv[1]?.endsWith('.ts');
const isTsNode = process.env.TS_NODE_DEV || process.env.TS_NODE_PROJECT;
const customApiFolderPath = isTsx || isTsNode ? '/src/api' : '/dist/api';

export const resturaConfigSchema = z.object({
	authToken: z.string().min(1, 'Missing Restura Auth Token'),
	sendErrorStackTrace: z.boolean().default(false),
	schemaFilePath: z.string().default(process.cwd() + '/restura.schema.json'),
	customApiFolderPath: z.string().default(process.cwd() + customApiFolderPath),
	generatedTypesPath: z.string().default(process.cwd() + '/src/@types'),
	fileTempCachePath: z.string().optional(),
	scratchDatabaseSuffix: z.string().optional(),
	eventDelivery: z.enum(['direct', 'outbox']).default('direct'),
	eventOutbox: z
		.object({
			channel: z.string().default('restura_outbox'),
			pollIntervalMs: z.number().default(15000),
			batchSize: z.number().default(50),
			maxAttempts: z.number().default(5),
			pruneAfterDays: z.number().default(7)
		})
		.prefault({}),
	notifyValidation: z.enum(['off', 'warn', 'strict']).default('warn'),
	queryMetadataKeys: z.union([z.literal('ALL'), z.array(z.string())]).optional()
});
export type ResturaConfigSchema = z.infer<typeof resturaConfigSchema>;
